import { links } from "../../../functions/links";
import Modal from "../../../module/modal/Modal";
import ResumenJudicial from "../../Gestion_pagos/Modals/ResumenJudicial";
import Juicio from "./modals/Juicio";
import Tabla_judiciales from "./tablas/Tabla_judiciales";
import "../../shared/styles/ViewContainer.css";

const GastosComponent = ({
  data,
  onClick,
  onChange,
  setSteps,
  steps,
  usuario,
  form,
  setForm,
  setResumenJudicial,
  resumenJudicial,
  setJuicio,
  juicio,
}) => {
  return (
    <div className="view-container">
      <div className="view-header">
        <h3 className="view-title">GASTOS JUDICIALES</h3>
        <div className="view-actions">
          <label className="btn-add-primary">
            <i className="bi bi-plus-lg me-2"></i>
            Crear Gasto
            <button
              data-bs-toggle="modal"
              data-bs-target="#crear-gasto"
              className="d-none"
            ></button>
          </label>
        </div>
      </div>

      <div className="view-search">
        <div className="search-group">
          <i className="bi bi-search search-icon"></i>
          <input
            type="text"
            className="search-input"
            placeholder="Buscar por persona"
            name="search"
            onChange={(e) => {
              if (e.target.value.length >= 3 || e.target.value.length === 0) {
                onClick(e, null);
              }
            }}
          />
        </div>
      </div>

      <div className="view-content">
        {data ? (
          <div>
            <div className="pagination-container fade-in">
              <div className="pagination-info">
                Total: {data.total} registros
              </div>
              <div className="pagination-buttons">
                {data.links.map((l, index) => {
                  if (index == 0) {
                    return (
                      <button
                        key={index}
                        className="pagination-btn"
                        name="anterior"
                        onClick={(event) => onClick(event)}
                      >
                        <i className="bi bi-arrow-left"></i>
                      </button>
                    )
                  }

                  if (index == (data.links.length - 1)) {
                    return (
                      <button
                        key={index}
                        className="pagination-btn"
                        name="siguiente"
                        onClick={(event) => onClick(event)}
                      >
                        <i className="bi bi-arrow-right"></i>
                      </button>
                    )
                  }

                  return (
                    <button
                      key={index}
                      className={l.active ? "pagination-btn pagination-btn-active" : "pagination-btn"}
                      name="link"
                      onClick={(event) => onClick(event, l.label)}
                    >
                      {l.label}
                    </button>
                  )
                })}
              </div>
            </div>

            <Tabla_judiciales
              data={data.data}
              onClick={onClick}
              onChange={onChange}
            />
          </div>
        ) : (
          <div className="empty-state">
            <span className="empty-state-text">No hay gastos judiciales registrados</span>
          </div>
        )}
      </div>

      <Modal
        title="Resumen de pagos"
        id="resumen-gastos"
        width={"1500px"}
        steps={steps}
        setSteps={setSteps}
        onClose={{
          name: "close",
          function: onClick,
        }}
        children={
          resumenJudicial ? (
            <ResumenJudicial
              data={null}
              juicio={juicio}
              setModal={setResumenJudicial}
              setSteps={setSteps}
              steps={steps}
              onClose={onClick}
            />
          ) : (
            ""
          )
        }
      />

      <Modal
        title="CREAR GASTO"
        id="crear-gasto"
        width={"700px"}
        steps={steps}
        setSteps={setSteps}
        onClick={{
          title: "GUARDAR",
          name: "crear-gasto",
          function: () => {
            onClick({ target: { name: "crear-gasto" } });
          },
        }}
        onClose={{
          id: "btn-close-modal",
          name: "close",
          function: onClick,
        }}
        children={
          <Juicio
            setSteps={setSteps}
            usuario={usuario}
            form={form}
            setForm={setForm}
          />
        }
      />
    </div>
  );
};

export default GastosComponent;
